﻿import React, { useRef, useState, useEffect } from 'react';
import Editor, { DiffEditor, useMonaco, loader } from '@monaco-editor/react';


//https://github.com/suren-atoyan/monaco-react


export default function MonacoEditorDemo() {
		
	return (
		<DiffEditor height="90vh" original="Some Text" modified="// Some other text" />
	);
	
	

}